var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconStartTutorial = function SvgIconStartTutorial(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FFE9A8"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M11 2.75.917 7.792 11 12.833l8.25-4.125v5.959h1.833V7.792z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M5.042 11.275v3.85c0 1.742 2.658 3.208 5.958 3.208s5.958-1.466 5.958-3.208v-3.85L11 14.3z"
  }))));
};
export default SvgIconStartTutorial;